<template>
  <header class="topbar">
    <div class="identity">
      <div class="sigil">B</div>
      <div>
        <strong>Backrooms</strong>
        <span>Layer Occupation System</span>
      </div>
    </div>

    <div class="top-actions">
      <template v-if="isLogin">
        <span style="color: var(--muted);">{{ displayName }}</span>
        <el-button class="login-entry-btn" :icon="User" @click="$emit('profile')">个人中心</el-button>
        <el-button class="login-entry-btn" :icon="SwitchButton" @click="$emit('logout')">退出</el-button>
      </template>
      <el-button v-else class="login-entry-btn" :icon="User" @click="$emit('login')">登录 / 注册</el-button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { SwitchButton, User } from '@element-plus/icons-vue';

defineProps<{
  isLogin: boolean;
  displayName: string;
}>();

defineEmits<{
  (e: 'login'): void;
  (e: 'logout'): void;
  (e: 'profile'): void;
}>();
</script>
